
export const findUs = () => {

	let locationSearchButton = document.getElementById('location-search');
	let locationSearchInput = document.querySelector('.find-us__address-input input[name="location-search"]');

	if (locationSearchButton && locationSearchInput) {
	    locationSearchButton.addEventListener('click', function() {
	        
	        let address = locationSearchInput.value;
			let encodedAddress = encodeURIComponent(address);
			window.location.href = '/locations?address=' + encodedAddress;
	    
	    });
	}

	const currentLocationTriggers = document.querySelectorAll('.js-current-loc-trigger');

    if (currentLocationTriggers) {
        currentLocationTriggers.forEach(trigger => {
            trigger.addEventListener("click", () => {

                // Use the browser's geolocation API
                navigator.geolocation.getCurrentPosition((pos) => {
                    const coords = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    };

					window.location.href = '/locations?lat=' + coords.lat + '&lng=' + coords.lng;
                },
                (error) => {
                    alert("Sorry, we couldn't locate you right now.");
                },
                {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0,
                });
            });
        });
    }
}
